module.exports = __webpack_public_path__ + "media/images/icons/SVG/038-7eae2094988f8267366c6ef0e3c103b7.svg";